<ion-content class="ion-justify-content-center content">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Customer Payment</ion-card-title>
      <ion-card-subtitle
        >Review your invoice and then complete the form below to make a one-time
        payment.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-grid>
      <ion-row class="ion-align-items-center">
        <ion-col size="10" offset="1" size-lg="5" offset-lg="0">
          <ion-button
            shape="round"
            expand="block"
            class="button-red"
            (click)="getCustomerInvoice()"
          >
            View My Invoice
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row class="ion-align-items-center">
        <ion-col size="10" offset="1" size-lg="5" offset-lg="0">
          <ion-button
            shape="round"
            expand="block"
            class="button-blue"
            (click)="backToPaymentPortal()"
          >
            Return to Payment Portal
          </ion-button>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <p>Amount Due: ${{ customerInvoice.amount }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <p>Description: {{ customerInvoice.description }}</p>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <mat-label
            >Select how you would like to pay the balance on your
            invoice.</mat-label
          >
          <mat-radio-group
            required
            [value]="paymentMethod"
            color="radio-color"
            class="radio-group"
          >
            <mat-radio-button value="CreditCard" (change)="setCreditCard()"
              ><p>Credit Card</p></mat-radio-button
            ><br />
            <mat-radio-button value="ECheck" (change)="setECheck()"
              ><p>Electronic Check</p></mat-radio-button
            >
          </mat-radio-group>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
  <br />

  <div *ngIf="paymentMethod === 'CreditCard'">
    <ion-card class="form-padding">
      <ion-row>
        <ion-col>
          <app-credit-card-payment
            [amountDue]="amountDue"
            (submitPayment)="completeCreditCardPayment($event)"
          >
          </app-credit-card-payment>
        </ion-col>
      </ion-row>
    </ion-card>
  </div>

  <div *ngIf="paymentMethod === 'ECheck'">
    <ion-card>
      <ion-row>
        <ion-col>
          <app-echeck-payment
            [amountDue]="amountDue"
            (submitPayment)="completeECheckPayment($event)"
          >
          </app-echeck-payment>
        </ion-col>
      </ion-row>
    </ion-card>
  </div>
</ion-content>
